import axios from 'axios'
import { reportProblem } from '../utils/problems'

// Which build of the website made a request (vite.config.js), for the
// control panel's problem reports.
const BUILD = typeof __ASYS_BUILD__ !== 'undefined' ? __ASYS_BUILD__ : 'dev'

// In dev AND prod, the frontend only ever talks to /api.
// In dev, Vite will proxy /api → https://asysretail.com.
// In prod, Caddy proxies /api → Flask.
const baseURL = '/api'

export const api = axios.create({
  baseURL,
  withCredentials: true, // send/receive cookies
})

// Optional: dev actor headers for audit trail
try {
  api.interceptors.request.use((config) => {
    const an = localStorage.getItem('actorName') || ''
    const aid = localStorage.getItem('actorId') || ''
    const lastActivityAt = localStorage.getItem('asysLastActivityAt') || ''
    if (an) config.headers['X-Actor'] = an
    if (aid) config.headers['X-User-Id'] = aid
    if (lastActivityAt) config.headers['X-ASYS-Last-Activity-At'] = lastActivityAt
    config.headers['X-ASYS-Build'] = BUILD
    return config
  })
} catch { }

// Normalize API errors so callers can consistently render messages + field errors
try {
  api.interceptors.response.use(
    (res) => res,
    (err) => {
      const resp = err?.response
      const data = resp?.data
      // No answer at all (the server unreachable, a timeout): the server can't
      // record that itself, so the page reports it; errors with a status it did.
      if (!resp && err?.code !== 'ERR_CANCELED' && !String(err?.config?.url || '').includes('/problems/report')) {
        reportProblem({ message: `Couldn’t reach the server: ${String(err?.config?.method || 'get').toUpperCase()} ${err?.config?.url || ''}`, detail: err?.message })
      }
      const e = new Error(
        (data && (data.error || data.message)) ||
        err.message ||
        'Request failed'
      )
      if (data && typeof data === 'object') {
        e.fields = data.fields || {}
        e.data = data
      }
      e.status = resp?.status
      if (resp?.status === 401 && typeof window !== 'undefined') {
        try { window.dispatchEvent(new CustomEvent('asys:session-expired')) } catch {}
      }
      // A part the plan doesn't have: the plan may have changed since this
      // tab loaded, so the app reads it again (App.jsx).
      if (resp?.status === 403 && data?.code === 'module_off' && typeof window !== 'undefined') {
        try { window.dispatchEvent(new CustomEvent('asys:plan-changed')) } catch {}
      }
      // An accountant whose client removed them: the server has put them
      // back in their practice (App.jsx takes them to their Clients).
      if (resp?.status === 403 && data?.code === 'client_access_removed' && typeof window !== 'undefined') {
        try { window.dispatchEvent(new CustomEvent('asys:practice-changed', { detail: { message: data.message } })) } catch {}
      }
      return Promise.reject(e)
    }
  )
} catch { }
